<cm-indicator class="icon" [placement]="tooltipPlacement" container="body" [ngbTooltip]="onBehalfTooltip">{{
    indicatorRoleLabel
}}</cm-indicator>
